import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
} from '@angular/core';
import {
  email,
  form,
  FormField,
  required,
  submit,
} from '@angular/forms/signals';
import { FieldsetComponent } from '@zion/frontend/shared-utils-ui';
import { firstValueFrom } from 'rxjs';
import { ContentContainer } from '../../../../core/content-container/content-container';
import { AddEmailToMailingListService } from '../../services/add-email/add-email-to-mailing-list.service';
import { RegisterLeadService } from '../../services/register-lead/register-lead.service';

export const COMMUNITY_WHATSAPP_GROUP_URL =
  'https://chat.whatsapp.com/IC1xQUy6xQm1WbUSLInjwQ';

@Component({
  selector: 'app-community',
  imports: [ContentContainer, FieldsetComponent, FormField],
  templateUrl: './community.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Community {
  private addEmailToMailingListService = inject(AddEmailToMailingListService);
  private registerLeadService = inject(RegisterLeadService);

  formModel = signal({
    email: '',
  });

  form = form(this.formModel, (schema) => {
    required(schema.email, { message: 'Campo obrigatório' });
    email(schema.email, { message: 'Email inválido' });
  });

  submit(event: Event) {
    event.preventDefault();

    submit(this.form, async () => {
      await Promise.allSettled([
        this.addEmailToMailingList(),
        this.registerLead(),
      ]);

      this.form().reset({ email: '' });
      this.redirectToCommunityGroup();

      return null;
    });
  }

  private addEmailToMailingList() {
    return firstValueFrom(
      this.addEmailToMailingListService.addEmail({
        email: this.form.email().value(),
        mailingListId: '463950',
      }),
    );
  }

  private registerLead() {
    return firstValueFrom(
      this.registerLeadService.registerLead({
        email: this.form.email().value(),
      }),
    );
  }

  private redirectToCommunityGroup() {
    // A top-level anchor click navigates without a popup; submit only runs in
    // the browser, so this is never executed during SSR prerendering.
    const anchor = document.createElement('a');
    anchor.href = COMMUNITY_WHATSAPP_GROUP_URL;
    anchor.click();
  }
}
